import { render } from "./LoginPopup.vue?vue&type=template&id=aa5344e4&scoped=true"
import script from "./LoginPopup.vue?vue&type=script&lang=js"
export * from "./LoginPopup.vue?vue&type=script&lang=js"

import "./LoginPopup.vue?vue&type=style&index=0&id=aa5344e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5344e4"]])

export default __exports__